<script setup lang="ts">
import { useRouteQuery } from '@vueuse/router'

const props = defineProps<{
  productLineId?: number
  selectedCategoryId?: number
}>()

const itemsPerPage = ref(12)
const page = useRouteQuery('page', 1, { transform: Number })
const referencesRepository = createReferencesRepository()

const { data: references, status } = await useLazyAsyncData(
  () =>
    referencesRepository.getAllPagination(
      page.value,
      itemsPerPage.value,
      props.selectedCategoryId,
      props.productLineId
    ),
  {
    watch: [page],
    default: defaultPaginationObject,
  }
)

const referencesElement = ref<HTMLElement | null>()
watch(page, () => {
  referencesElement.value?.scrollIntoView({ behavior: 'smooth' })
})
</script>

<template>
  <section ref="referencesElement" class="container py-16">
    <div>
      <div
        v-if="status === 'pending'"
        class="mb-8 grid gap-10 px-2 md:grid-cols-2"
      >
        <!-- TODO: Correct skeleton -->
        <UiSkeletonReferencesCard
          v-for="_ in itemsPerPage"
          class="w-1/2"
        ></UiSkeletonReferencesCard>
      </div>
      <div v-else class="mb-8 grid grid-cols-1 gap-4 gap-y-12 md:grid-cols-2">
        <ReferencesCard
          v-for="reference in references.items"
          :key="reference.nid"
          class="w-full"
          :reference="reference"
        />
      </div>
      <div class="flex justify-end pr-6">
        <UiPagination
          v-model:value="page"
          :items-per-page="itemsPerPage"
          :item-count="references.itemCount"
          :loading="status === 'pending'"
        />
      </div>
    </div>
  </section>
</template>

<style></style>
